export enum DidNotPurchaseReason {
	UNKOWN = 0,
	EXPENSIVE = 1,
	DIFFICULT = 2,
	NOT_ENOUGH_FUNCTIONALITY = 3,
	SCHOOL = 4,
	PREFERED_NOT_TO_SAY = 5,
	MISC = 7,
}


export class CompanyDidNotPurchaseReasons {
	public ID:number = 0;
	public CompanyID:number = 0;
	public ReasonID:DidNotPurchaseReason = 0;
	public ExtraData:string = "";

	public constructor(data?:any){
		if (!data) return;
		this.ID = data.ID;
		this.CompanyID = data.CompanyID;
		this.ReasonID = data.ReasonID;
		this.ExtraData = data.ExtraData;
	}

	public getJSON(){
		return {
			ID: this.ID,
			CompanyID: this.CompanyID,
			ReasonID: this.ReasonID,
			ExtraData: this.ExtraData
		};
	}
}